import { clsx } from "clsx";
import { useEffect, useState } from "react";

interface StickyProps {
  children: React.ReactNode;
  anchor?: "top" | "bottom";
  float?: boolean;
}

export const Sticky = ({
  children,
  anchor = "top",
  float = false,
}: StickyProps) => {
  const [isAtEdge, setIsAtEdge] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const isAtTop = window.scrollY < 60;

      setIsAtEdge(isAtTop);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      className={clsx("sticky z-40", {
        "bg-background": isAtEdge,
        "top-0": anchor === "top",
        "bottom-0": anchor === "bottom",
        "top-2 md:top-4 mx-4": anchor === "top" && float && !isAtEdge,
        "transition-all duration-200": float,
      })}
    >
      <div
        className={clsx("w-full rounded-full bg-background", {
          "overflow-clip px-2 md:py-2 shadow page-max-width":
            anchor === "top" && float && !isAtEdge,
          "shadow-fab": !float,
        })}
      >
        {children}
      </div>
    </div>
  );
};
